import React from 'react';
import { Link } from 'react-router-dom';
import '../BitsStyles/Footer.css';
import logo from '../BitsImages/logoooo12345.jpg';

const companyLinks = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about-us' },
  { label: 'Services', to: '/service-bits' },
  { label: 'Billing Solutions', to: '/billing' },
  { label: 'Careers', to: '/career-bits' },
  { label: 'Contact Us', to: '/contact-bits#contact-form' },
];

const capabilityLinks = [
  { label: 'Mobile Applications', to: '/projects' },
  { label: 'Web Applications', to: '/projects' },
  { label: 'Website Development', to: '/projects' },
  { label: 'Billing Solutions', to: '/projects' },
  { label: 'IT Support Projects', to: '/projects' },
];

const devLinks = [
  { label: 'Full Stack Developers', to: '/career-bits' },
  { label: 'Java Developers', to: '/career-bits' },
  { label: 'Backend Developers', to: '/career-bits' },
  { label: 'Frontend Developers', to: '/career-bits' },
  { label: 'React Developers', to: '/career-bits' },
  { label: 'MERN Stack Developers', to: '/career-bits' },
];

const socials = [
  { icon: 'bi-facebook', to: 'https://www.facebook.com/BellaryInfotech', label: 'Facebook' },
  { icon: 'bi-instagram', to: 'https://www.instagram.com/bellary_info_tech25?igsh=bm4wbm9ya3kydGQz', label: 'Instagram' },
  { icon: 'bi-linkedin', to: 'https://www.linkedin.com/company/bellary-infotech-solutions', label: 'LinkedIn' },
  { icon: 'bi-twitter-x', to: 'https://x.com/home?lang=en-in', label: 'Twitter / X' },
];

const Footer = () => (
  <footer className="ft-footer">
    <div className="ft-inner">
      {/* Brand column */}
      <div className="ft-brand">
        <Link to="/" className="ft-logo">
          <img src={logo} alt="BITS Logo" className="ft-logo-img" />
          <div className="ft-logo-text">
            <span className="ft-logo-main">Bellary</span>
            <span className="ft-logo-sub">Info Tech Solutions</span>
          </div>
        </Link>
        <p className="ft-tagline">
          Empowering businesses with smart software solutions — web apps, mobile apps, and billing systems.
        </p>
        <div className="ft-socials">
          {socials.map((s, i) => (
            <Link key={i} to={s.to} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="ft-social-btn">
              <i className={`bi ${s.icon}`}></i>
            </Link>
          ))}
        </div>
      </div>

      {/* Links columns */}
      <div className="ft-cols">
        <div className="ft-col">
          <h4 className="ft-col-title">Company</h4>
          {companyLinks.map((l, i) => (
            <Link key={i} to={l.to} className="ft-link">{l.label}</Link>
          ))}
        </div>

        <div className="ft-col">
          <h4 className="ft-col-title">Capabilities</h4>
          {capabilityLinks.map((l, i) => (
            <Link key={i} to={l.to} className="ft-link">{l.label}</Link>
          ))}
        </div>

        <div className="ft-col">
          <h4 className="ft-col-title">Hire Developers</h4>
          {devLinks.map((l, i) => (
            <Link key={i} to={l.to} className="ft-link">{l.label}</Link>
          ))}
        </div>

        <div className="ft-col">
          <h4 className="ft-col-title">Reach Us</h4>
          <div className="ft-contact-item">
            <i className="bi bi-telephone-fill"></i>
            <a href="tel:+919603299266">+91 9603299266</a>
          </div>
          <div className="ft-contact-item">
            <i className="bi bi-telephone-fill"></i>
            <a href="tel:+919703299266">+91 9703299266</a>
          </div>
          <div className="ft-contact-item">
            <i className="bi bi-envelope-fill"></i>
            <a href="mailto:info@bellaryinfotech.com">info@bellaryinfotech.com</a>
          </div>
          <div className="ft-contact-item ft-address">
            <i className="bi bi-geo-alt-fill"></i>
            <a href="https://www.google.com/maps/place/15%C2%B009'42.8%22N+76%C2%B056'18.5%22E/@15.1618988,76.9358962,17z" target="_blank" rel="noopener noreferrer">Plot No 7, Ward No 18/21, Kappagal Road, M V Nagar 9th Cross, Bellary 583103</a>
          </div>
        </div>
      </div>
    </div>

    {/* Bottom bar */}
    <div className="ft-bottom">
      <span>© {new Date().getFullYear()} Bellary Info Tech Solutions. All rights reserved.</span>
      <div className="ft-bottom-links">
        <Link to="/" className="ft-bottom-link">Privacy Policy</Link>
        <Link to="/" className="ft-bottom-link">Terms &amp; Conditions</Link>
        <Link to="/" className="ft-bottom-link">Legal Disclaimer</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
